import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/SynonymRulePreview.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/search/preview/synonyms`;
	}
	preview(e, t, r) {
		return this.api.post(this.buildPath(`${n.baseUrl}/new`, {
			trackingId: t,
			...r ? { id: r } : {}
		}), e);
	}
};
//#endregion
export { n as SynonymRulePreview };

//# sourceMappingURL=SynonymRulePreview.js.map